module.exports = __webpack_public_path__ + "img/custom-11.198dcc9f.svg";